import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import styles from './Body.module.scss';

interface IModalBodyProps {
  children: React.ReactNode;
  className?: string;
}

const ModalBody: FC<IModalBodyProps> = ({ children, className }) => {
  return <main className={classes([styles.body, className])}> {children}</main>;
};

export default observer(ModalBody);
